import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-067014fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-title" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "pickup-input-content" }
const _hoisted_5 = { class: "input-section" }
const _hoisted_6 = ["placeholder", "onKeyup"]
const _hoisted_7 = { class: "description-text" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "dialog-btn-group len-2" }
const _hoisted_11 = { class: "dialog-title" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "pickup-insufficient-content" }
const _hoisted_15 = { class: "description-text" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "dialog-btn-group len-1" }

import { ref, reactive, inject, Ref } from 'vue';
  import ApplyAction from './action.vue';
  import { useI18n } from 'vue-i18n';

  interface IProps {
    minimumNumber: number;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    minimumNumber: null
  },
  emits: ['confirm', 'cancel'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
    minimumNumber: number;
  }

  const { t } = useI18n();
  
  

  const applyActionTeleportNode = inject<Ref<HTMLDivElement>>('applyActionTeleportNode');
  const showApplyAction = inject<() => void>('showApplyAction');
  const hideApplyAction = inject<() => void>('hideApplyAction');

  const dialog = reactive({
    input: false,
    insufficient: false,
  });

  const inputNumber = ref<number | null>(null);

  function show() {
    inputNumber.value = null;
    dialog.input = true;
    showApplyAction && showApplyAction();
  }

  function closeDialog() {
    dialog.input = false;
    dialog.insufficient = false;
    hideApplyAction && hideApplyAction();
  }

  function handleCancel() {
    closeDialog();
    emit('cancel');
  }

  function handleConfirm() {
    // 验证输入
    if (inputNumber.value === null || inputNumber.value === undefined || inputNumber.value <= 0) {
      return;
    }

    // 检查是否达到最低数量
    if (inputNumber.value < props.minimumNumber) {
      dialog.input = false;
      dialog.insufficient = true;
      return;
    }

    // 数量达标，触发确认事件
    closeDialog();
    emit('confirm', inputNumber.value);
  }

  function handleInsufficientClose() {
    closeDialog();
    emit('cancel');
  }

  expose({
    show
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, {
    to: _unref(applyActionTeleportNode) ? _unref(applyActionTeleportNode) : 'body'
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps({
      visible: _unref(dialog).input,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).input) = $event))
    }, _unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program dialog-pickup-popup' }), {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            class: "d-none d-md-block",
            innerHTML: _unref(t)('popup_input_title')
          }, null, 8, _hoisted_2),
          _createElementVNode("span", {
            class: "d-block d-md-none",
            innerHTML: _unref(t)('popup_input_title_mobile')
          }, null, 8, _hoisted_3)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: handleConfirm
          }, _toDisplayString(_unref(t)('popup_button_confirm')), 1),
          _createElementVNode("button", {
            class: "btn btn-outline-primary",
            onClick: handleCancel
          }, _toDisplayString(_unref(t)('popup_button_cancel')), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputNumber).value = $event)),
              type: "number",
              class: "number-input",
              placeholder: _unref(t)('popup_input_placeholder'),
              min: "0",
              onKeyup: _withKeys(handleConfirm, ["enter"])
            }, null, 40, _hoisted_6), [
              [
                _vModelText,
                inputNumber.value,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", {
              class: "d-none d-md-block",
              innerHTML: _unref(t)('popup_input_description')
            }, null, 8, _hoisted_8),
            _createElementVNode("span", {
              class: "d-block d-md-none",
              innerHTML: _unref(t)('popup_input_description_mobile')
            }, null, 8, _hoisted_9)
          ])
        ])
      ]),
      _: 1
    }, 16, ["visible"])),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps({
      visible: _unref(dialog).insufficient,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).insufficient) = $event))
    }, _unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program dialog-pickup-popup' }), {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", {
            class: "d-none d-md-block",
            innerHTML: _unref(t)('popup_insufficient_title')
          }, null, 8, _hoisted_12),
          _createElementVNode("span", {
            class: "d-block d-md-none",
            innerHTML: _unref(t)('popup_insufficient_title_mobile')
          }, null, 8, _hoisted_13)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: handleInsufficientClose
          }, _toDisplayString(_unref(t)('popup_button_close')), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", {
              class: "d-none d-md-block",
              innerHTML: _unref(t)('popup_insufficient_description', { minimum: __props.minimumNumber })
            }, null, 8, _hoisted_16),
            _createElementVNode("span", {
              class: "d-block d-md-none",
              innerHTML: _unref(t)('popup_insufficient_description_mobile', { minimum: __props.minimumNumber })
            }, null, 8, _hoisted_17)
          ])
        ])
      ]),
      _: 1
    }, 16, ["visible"]))
  ], 8, ["to"]))
}
}

})